// extracted by mini-css-extract-plugin
export default {"toggleContainer":"Toggle_toggleContainer__tT604"};